<div
	class="modal fade"
	id="buyPlan"
	tabindex="-1"
	role="dialog"
	aria-hidden="true"
	data-bs-backdrop="static"
	data-bs-keyboard="false"
>
	<div class="modal-dialog modal-dialog-centered" role="document">
		@if (buyPlanParams) {
		<div class="modal-content">
			<div class="modal-body text-center">
				<h4>
					<strong>{{ 'modals.buyPlan.actionNotPossible' | translate }}</strong>
				</h4>
				<div class="my-3">
					{{ 'modals.buyPlan.notEnoughCoins' | translate }}
					<strong>{{ transformText() | uppercase }}</strong>
				</div>
				<div class="row m-0 my-3">
					<div class="col text-center">
						<div>{{ 'modals.buyPlan.required' | translate }}</div>
						<h2>
							<strong>{{ buyPlanParams.necessary }}</strong>
						</h2>
					</div>
					<div class="col text-center">
						<div>{{ 'modals.buyPlan.available' | translate }}</div>
						<h2 class="text-danger">
							<strong>{{ buyPlanParams.available }}</strong>
						</h2>
					</div>
				</div>
			</div>
			<div class="modal-footer justify-content-center">
				<button
					data-bs-dismiss="modal"
					(click)="go()"
					routerLinkActive="router-link-active"
					class="btn btn-primary"
				>
					{{ 'modals.buyPlan.getMore' | translate }}
				</button>
			</div>
		</div>
		}
	</div>
</div>
